// import React from 'react';
// import { Link } from 'react-router-dom';
// import Icon from '../../../components/AppIcon';

// const ServicesSection = () => {
//   const services = [
//     {
//       id: 1,
//       title: "Web Development",
//       description: "Custom web applications built with modern frameworks like React, Vue, and Angular. Responsive, scalable, and optimized for performance.",
//       icon: "Globe",
//       features: ["Responsive Design", "SEO Optimized", "Fast Loading", "Cross-browser Compatible"],
//       color: "primary"
//     },
//     {
//       id: 2,
//       title: "Mobile App Development",
//       description: "Custom iOS and Android applications built with React Native, Flutter, or native development to deliver seamless user experiences",
//       icon: "Smartphone",
//       features: ["Native iOS/Android", "Cross-platform", "UI/UX Design", "App Store Optimization"],
//       color: "accent"
//     },

//     {
//       id: 3,
//       title: "Custom Software develpement",
//       description: "Scalable cloud infrastructure and deployment solutions. AWS, Azure, and Google Cloud expertise for reliable hosting.",
//       icon: "Cloud",
//       features: ["AWS/Azure/GCP", "Auto Scaling", "Security", "Cost Optimization"],
//       color: "success"
//     }
//   ];

//   const getColorClasses = (color) => {
//     switch (color) {
//       case 'primary':
//         return {
//           bg: 'bg-primary-50',
//           icon: 'text-primary',
//           border: 'border-primary-600',
//           hover: 'hover:border-primary'
//         };
//       case 'accent':
//         return {
//           bg: 'bg-accent-50',
//           icon: 'text-accent',
//           border: 'border-accent-600',
//           hover: 'hover:border-accent'
//         };
//       case 'success':
//         return {
//           bg: 'bg-success-50',
//           icon: 'text-success',
//           border: 'border-success-600',
//           hover: 'hover:border-success'
//         };
//       default:
//         return {
//           bg: 'bg-primary-50',
//           icon: 'text-primary',
//           border: 'border-primary-600',
//           hover: 'hover:border-primary'
//         };
//     }
//   };

//   return (
//     <section className="py-20 bg-surface">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Section Header */} 
//         <div className="text-center mb-16">
//           <h2 className="text-3xl sm:text-4xl font-bold text-text-primary mb-4">
//             Our Core Services
//           </h2>
//           <p className="text-xl text-text-secondary max-w-3xl mx-auto">
//             We deliver end-to-end technology solutions that help businesses innovate, transform, and grow
//             in today's digital landscape.
//           </p>
//         </div>

//         {/* Services Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {services.map((service) => {
//             const colorClasses = getColorClasses(service.color);

//             return (
//               <div
//                 key={service.id}
//                 className={`group bg-surface border-2 ${colorClasses.border} ${colorClasses.hover} rounded-xl p-8 transition-all duration-300 hover:shadow-xl hover:transform hover:scale-105`}
//               >
//                 {/* Icon */}
//                 <div className={`w-16 h-16 ${colorClasses.bg} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
//                   <Icon name={service.icon} size={32} className={colorClasses.icon} />
//                 </div>

//                 {/* Content */}
//                 <h3 className="text-xl font-bold text-text-primary mb-4">
//                   {service.title}
//                 </h3>

//                 <p className="text-text-secondary mb-6 leading-relaxed">
//                   {service.description}
//                 </p>

//                 {/* Features */}
//                 <ul className="space-y-2 mb-6">
//                   {service.features.map((feature, index) => (
//                     <li key={index} className="flex items-center text-sm text-text-secondary">
//                       <Icon name="Check" size={16} className={`mr-2 ${colorClasses.icon}`} />
//                       {feature}
//                     </li>
//                   ))}
//                 </ul>

//                 {/* Learn More Link */}
//                 <Link
//                   to="/Services"
//                   className={`inline-flex items-center text-sm font-semibold ${colorClasses.icon} hover:underline group-hover:translate-x-1 transition-transform duration-300`}
//                 >
//                   Learn More
//                   <Icon name="ArrowRight" size={16} className="ml-1" />
//                 </Link>
//               </div>
//             );
//           })}
//         </div>

//         {/* CTA Section */}
//         <div className="text-center mt-16">
//           <p className="text-text-secondary mb-6">
//             Need a custom solution? We're here to help you build something amazing.
//           </p>
//           <Link
//             to="/contact-page"
//             className="inline-flex items-center px-8 py-4 bg-primary text-white font-semibold rounded-lg hover:bg-primary-700 transition-all duration-300 shadow-lg hover:shadow-xl"
//           >
//             Get Started Today
//             <Icon name="ArrowRight" size={20} className="ml-2" />
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ServicesSection;

import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ServicesSection = () => {
  const headingRef = useRef(null);
  const cardRefs = useRef([]);
  const [animateHeading, setAnimateHeading] = useState(false);
  const [visibleCards, setVisibleCards] = useState([]);

  const services = [
    {
      id: 1,
      title: "Web Development",
      description: "Responsive web applications built with modern frameworks like React, Angular, or Vue.js, delivering powerful functionality across devices.",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Mobile App Development",
      description: "Custom iOS and Android applications built with React Native, Flutter, or native development to deliver seamless user experiences",
      icon: "Smartphone"
    },
    {
      id: 3,
      title: "Custom Software Development",
      description: "Tailored software solutions designed to address your specific business challenges and optimize your operations.",
      icon: "Cloud"
    },
    {
      id: 4,
      title: "Database Architecture",
      description: "Robust database design and implementation for efficient data storage, retrieval, and management with SQL and NoSQL solutions.",
      icon: "Database"
    },
    {
      id: 5,
      title: "UI/UX Design",
      description: "User-centered design that creates intuitive, engaging interfaces to maximize user satisfaction and business outcomes.",
      icon: "Webhook",
    },
    {
      id: 6,
      title: "Maintenance & Support",
      description: "Ongoing technical support, regular updates, and proactive maintenance to ensure your digital products remain secure and optimized.",
      icon: "Handshake"
    }
  ];

  // 🎯 ANIMATE HEADING FIRST
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimateHeading(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (headingRef.current) observer.observe(headingRef.current);
  }, []);

  // 🎯 INDIVIDUAL CARD OBSERVER
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cardId = entry.target.getAttribute("data-id");
            setVisibleCards((prev) => [...prev, cardId]);
            observer.unobserve(entry.target); // animate only once
          }
        });
      },
      { threshold: 0.3 }
    );

    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card);
    });
  }, []);

  return (
    <section className="py-8 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <div
          ref={headingRef}
          className={`text-center mb-8 transition-all duration-700 ${
            animateHeading ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"
          }`}
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-text-primary mb-4">
            Our Core Services
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            We deliver end-to-end technology solutions that help businesses innovate, transform, and grow in today's digital landscape.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <div
              key={service.id}
              data-id={String(service.id)}
              ref={(el) => (cardRefs.current[idx] = el)}
              className={`group bg-surface border-2 border-gray-200 rounded-xl p-6 
              transition-all duration-500 opacity-0
              ${
                visibleCards.includes(String(service.id))
                  ? "animate-scale-up"
                  : ""
              }
            `}
            >
              <div className="w-16 h-16 bg-primary-100 text-[#1e40af] rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                <Icon name={service.icon} size={32} />
              </div>
              <h3 className="text-xl font-bold text-text-primary mb-4">{service.title}</h3>
              <p className="text-text-secondary mb-2 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <p className="text-text-secondary mb-6">
            Need a custom solution? We're here to help you build something amazing.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center px-5 py-4 bg-primary text-white font-semibold rounded-lg hover:bg-primary-700 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Get Started Today
            <Icon name="ArrowRight" size={20} className="ml-2" />
          </Link>
        </div>
      </div>

      <style>
        {`
          @keyframes scaleUp {
            0% {
              opacity: 0;
              transform: scale(0.02);
            }
            100% {
              opacity: 1;
              transform: scale(1);
            }
          }

          .animate-scale-up {
            animation: scaleUp 0.5s ease-out forwards;
          }
        `}
      </style>
    </section>
  );
};

export default ServicesSection;
